import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';
import NavBar from './shared/NavBar';
import Footer from './shared/Footer';

const PrivacyPolicy = () => {
  return (
    <Box sx={{ bgcolor: '#FAFAFA', minHeight: '100vh' }}>
      <NavBar />
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Paper elevation={2} sx={{ p: 4, borderRadius: '16px' }}>
          <Typography variant="h3" gutterBottom sx={{ color: '#FF6B35', fontWeight: 'bold', mb: 3 }}>
            Privacy Policy
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mb: 3 }}>
            At YoungPresso, we are committed to protecting your privacy and the privacy of your children. 
            This Privacy Policy explains how we collect, use, and safeguard your information when you use our website and services.
            By using YoungPresso, you consent to the data practices described in this policy.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            1. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We may collect the following types of information:
            <ul>
              <li><b>Personal Information:</b> Name, email address, phone number, and payment information when you subscribe to our services.</li>
              <li><b>Child Information:</b> Age, gender, and interests of your child to provide appropriate content.</li>
              <li><b>Usage Data:</b> Information about how you access and use our website, including your IP address, browser type, and device information.</li>
              <li><b>Cookies:</b> We use cookies to enhance your experience on our website and collect information about usage patterns.</li>
            </ul>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            2. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We use the collected information for various purposes, including:
            <ul>
              <li>Processing subscriptions and payments</li>
              <li>Providing and personalizing our services</li>
              <li>Communicating with you about your account or subscription</li>
              <li>Sending newsletters and promotional content (you can opt out at any time)</li>
              <li>Improving our website and services</li>
              <li>Analyzing usage patterns and trends</li>
            </ul>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            3. Children's Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            We are committed to protecting children's privacy. Our services are designed for children to use with parental supervision. 
            We do not knowingly collect personal information directly from children under 13 without verifiable parental consent. 
            If you believe we have inadvertently collected information from a child under 13, please contact us at <b>support@youngpresso.com</b> so we can promptly remove the information.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            4. Usage of Images
          </Typography>
          <Typography variant="body1" paragraph>
            As part of our contests and activities, we may collect and use images submitted by users for the following purposes:
            <ul>
              <li>To feature contest winners in our digital magazine</li>
              <li>To showcase student achievements and participation</li>
              <li>To display in our promotional materials with explicit consent</li>
            </ul>
            We want to assure you that:
            <ul>
              <li>Images are only used for the specific purpose they were submitted for</li>
              <li>After featuring the images in our magazine or promotional materials, we delete them from our active systems</li>
              <li>We do not share these images with third parties</li>
              <li>Parents/guardians can request removal of their child's images at any time by contacting <b>support@youngpresso.com</b></li>
            </ul>
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            5. Data Security
          </Typography>
          <Typography variant="body1" paragraph>
            We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. 
            However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            6. Third-Party Services
          </Typography>
          <Typography variant="body1" paragraph>
            We use third-party services for payment processing (Razorpay) and analytics. These third parties have their own privacy policies, and we recommend reviewing their policies to understand how they handle your information.
            We do not store your credit/debit card information on our servers.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            7. Your Rights
          </Typography>
          <Typography variant="body1" paragraph>
            You have the right to:
            <ul>
              <li>Access, update, or delete your personal information</li>
              <li>Opt out of marketing communications</li>
              <li>Request information about how your data is being used</li>
            </ul>
            To exercise these rights, please contact us at <b>support@youngpresso.com</b>.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            8. Changes to This Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="body1" paragraph sx={{ fontStyle: 'italic' }}>
            Last updated: April 27, 2025
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about this Privacy Policy, please contact us at <b>support@youngpresso.com</b>.
          </Typography>
        </Paper>
      </Container>
      <Footer />
    </Box>
  );
};

export default PrivacyPolicy;
